import React, {
  startTransition,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { fetcher as fetcherAPI } from '../../helpers/fetcher'
import { createScenarioFuturesTableFinal } from '../../helpers/helpers'
import { getFuturesTablesByScenarioSet } from '../../helpers/phenomenonFetcher'
import { ACTIONS } from '../../store/Actions'
import { DataContext } from '../../store/GlobalState'
import shape from './icons/Shape.svg'
import { Container, DriversContent, DriversImg, DriversTitle } from './styles'

const Drivers = ({ drivers, driversFuturesTables, scenario, scenarioSet }) => {
  const cardBodyRef = useRef()
  const cardBodyRef2 = useRef()

  const {
    state: {
      langForTransState,
      isTranslated,
      scenarioSet: scenarioSetState,
      scenario: scenarioState,
      driversFuturesTables: driversFuturesTablesState,
      driversDOM,
    },
    dispatch,
  } = useContext(DataContext)

  const [translations, settranslations] = useState(null)
  const [originalTitle, setoriginalTitle] = useState(
    () => cardBodyRef.current?.innerHTML,
  )

  // const [driversFuturesTables, setdriversFuturesTables] = useState(null)
  // useEffect(() => {
  //   const fetcher = async () => {
  //     const res1 = await getFuturesTablesByScenarioSet(scenarioSet?.id)
  //     console.log('res1', res1)
  //     const futuresTables = createScenarioFuturesTableFinal(
  //       res1?.data[0]?.matrix,
  //       [scenario],
  //     )
  //     const returningData = !!futuresTables?.length
  //       ? futuresTables?.filter((ft) => ft?.id === scenario?.id)
  //       : []
  //     console.log('futuresTables', returningData)
  //     setdriversFuturesTables(() =>
  //       !!returningData?.length ? returningData[0] : null,
  //     )
  //   }
  //   scenarioSet?.id && fetcher()
  // }, [scenarioSet?.id, scenario])
  useEffect(() => {
    const fetcher = async () => {
      const res1 = await fetcherAPI.translation(
        'en',
        langForTransState,
        originalTitle,
      )
      settranslations(() => {
        return {
          res1,
        }
      })
    }
    !!isTranslated && !!originalTitle && fetcher()
  }, [isTranslated, originalTitle, langForTransState])

  useEffect(() => {
    if (!!scenario?.verbalDrivers?.length || drivers) {
      if (true) {
        if (!!cardBodyRef.current?.innerHTML && !cardBodyRef2.current) {
          cardBodyRef2.current = cardBodyRef.current?.innerHTML
        }
        !!cardBodyRef2.current &&
          !originalTitle &&
          setoriginalTitle(() => cardBodyRef2.current)

        // dispatch({
        //   type: ACTIONS.GETWHOLEHTMLCARD2,
        //   payload:  true
        // })
      }
    }
  }, [isTranslated, drivers, scenario?.verbalDrivers, dispatch, originalTitle])
  const [isDriversOpened, setisDriversOpened] = React.useState(true)
  const openingDriversHandler = () => {
    setisDriversOpened(() => !isDriversOpened)
  }

  useEffect(() => {
    startTransition(() => {
      setTimeout(() => {
        dispatch({
          type: ACTIONS.DRIVERSDOM,
          payload: cardBodyRef.current?.outerHTML,
        })
      }, 1000)
    })
  }, [isTranslated, dispatch, originalTitle, translations])

  return (
    <>
      {!!scenario?.verbalDrivers?.length ||
      (!scenario?.verbalDrivers &&
        !!drivers?.length &&
        !!scenario?.drivers?.length) ? (
        <>
          {!isTranslated ? (
            <Container ref={cardBodyRef}>
              <DriversTitle>Drivers used in this scenario:</DriversTitle>
              <ul
                style={{
                  paddingLeft: '12px',
                  marginTop: '0.5rem',
                  marginBottom: '0.5rem',
                }}>
                {scenarioSetState?.type === 'futures_table' ? (
                  <>
                    {isDriversOpened &&
                      driversFuturesTablesState?.matrixCells?.map(
                        (info, index) => (
                          <div style={{ fontSize: '13px' }}>
                            <li key={index}>
                              {info?.driver}
                              {': '}
                              <strong>{info?.content}</strong>
                              {/* Content from Futures table:{' '}
                            <strong>{info?.content}</strong>
                            {' in the '}
                            <strong>{info?.driver}</strong>
                            {' that is marked with '}
                            <strong>{info?.color}</strong>
                            {' on '}
                            <strong>{info.futureState}</strong> */}
                            </li>
                          </div>
                        ),
                      )}
                  </>
                ) : (
                  <>
                    {!!isDriversOpened &&
                      !!scenario?.verbalDrivers?.length &&
                      scenario?.verbalDrivers?.map((driver, index) => {
                        return (
                          <DriversContent key={index}>{driver}</DriversContent>
                        )
                      })}
                    {!!isDriversOpened &&
                      !scenario?.verbalDrivers &&
                      !!drivers?.length &&
                      !!scenario?.drivers?.length && (
                        <>
                          <DriversContent>
                            {drivers[1]?.title + `: `}
                            {` `}
                            {Number(scenario?.drivers[1]) === 1 ? 'Max' : 'Min'}
                          </DriversContent>
                          <DriversContent>
                            {drivers[0]?.title + `: `}{' '}
                            {Number(scenario?.drivers[0]) === 1 ? 'Max' : 'Min'}
                          </DriversContent>
                        </>
                      )}
                  </>
                )}
              </ul>
              <DriversImg
                src={shape}
                onClick={openingDriversHandler}
                style={{
                  transform: `rotate(${!!isDriversOpened ? '0' : '180deg'})`,
                }}
              />
            </Container>
          ) : (
            <Container
              ref={cardBodyRef}
              dangerouslySetInnerHTML={{
                __html: translations?.res1?.data,
              }}></Container>
          )}
        </>
      ) : null}
    </>
  )
}

export default Drivers
